import React, { useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, matchPath, useLocation } from 'react-router';
import NavBadgeContext from '../../contexts/NavBadgeContext';

type Props = {
    title: string;
    icon: React.ReactNode;
    route: string;
    onClick: () => void;
}

const MobileHeaderRow = (props: Props) => {
    let location = useLocation()
    const { t } = useTranslation();
    const styledIcon = React.cloneElement(props.icon as any, {
        className: "flex justify-center items-center w-full h-full", // or any additional props you want to pass
        style: { fontSize: "34px" }
    });
    const [isSelected, setIsSelected] = React.useState(false);
    const { getValue, hasValue } = useContext(NavBadgeContext);

    useEffect(() => {
        const isMatching = matchPath(props.route, location.pathname);
        setIsSelected(isMatching != null ? true : false);
    }, [location]);

    function getLinkColor() {
        if (isSelected) {
            return 'bg-utility-mutedLight text-primary-dark'
        }
        return 'bg-primary hover:bg-primary-light text-white'
    }

    return (
        <Link to={props.route} onClick={props.onClick} className={`relative flex gap-1 bg-primary rounded-[8px] py-[8px] px-[4px] ${getLinkColor()}`}>
            <div className="px-2">
                {styledIcon}
            </div>
            <div className="font-bold text-[18px] flex  items-center w-full h-full">
                {t("common.titles." + props.title)}
            </div>
            {hasValue(props.title) && (
                <div className="absolute top-0 right-0 bg-strike text-white font-bold rounded-full w-6 h-6 flex justify-center items-center p-4 mt-2 mr-2">
                    {getValue(props.title)}
                </div>
            )}
        </Link>
    )
}

export default MobileHeaderRow